import styled, { css } from 'styled-components';

export const StyledCard = styled.div`
  margin-bottom: 12px;
`;

export const NoteWrapper = styled.div<{ isDoctor: boolean }>`
  background-color: #f3f6fd;
  padding: 14px 20px;
  border-radius: 8px;
  ${({ isDoctor }) =>
    isDoctor &&
    css`
      border: 1px solid #c8d2e6;
      background-color: transparent;
    `};
`;

export const Content = styled.div`
  max-width: 50%;
`;

export const NoteInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 16px;
`;
